export function isError(error) {
    return Boolean(error) && error instanceof Error;
}
//# sourceMappingURL=isErrorLike.js.map